import { Button, Center, HStack, VStack } from '@chakra-ui/react'
import React, { useCallback, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { REPOSITORY } from '../../api/repository/Repository'
import InputForm from '../../components/InputForm/InputForm'
import UnderlineHeading from '../../components/UnderlineText/UnderlineHeading'
import { useCompanyData } from '../../utils/hooks/company/useCompanyData'
import { useLoadingContext } from '../../utils/hooks/Context/LoadingContext'
import { useRequestStatusContext } from '../../utils/hooks/Context/RequestStatusContext'

export default function NewCostCenter() {
  const navigate = useNavigate()
  const [costCenterName, setCostCenterName] = useState('')
  const { searchCompanyData } = useCompanyData()
  const { handleOpen: handleOpenLoading, handleClose: handleCLoseLoading } =
    useLoadingContext()
  const { handleOpen, handleSetTitle, handleChangeBody, handleClose } =
    useRequestStatusContext()
  const { sEmpresa } = REPOSITORY.local.company.getCompanyData()
  const onCostCenterChange = (event) => setCostCenterName(event.target.value)
  const onGoBack = () => {
    navigate(-1)
  }

  const onStatusOK = (res, message) => {
    handleCLoseLoading()
    setCostCenterName('')
    handleSetTitle(message, res.status)
    handleChangeBody(
      <Button
        style={{ borderRadius: 10 }}
        variant="primary"
        onClick={() => {
          handleClose()
        }}
      >
        {'Continuar'}
      </Button>,
    )
    handleOpen()
  }

  const onStatusError = () => {
    handleCLoseLoading()
    handleSetTitle('Centro de costo ya existe', 400)
    handleChangeBody(
      <Button
        variant="primary"
        onClick={() => {
          handleClose()
        }}
      >
        Contactar a soporte ahora
      </Button>,
    )
    handleOpen()
  }
  const onSubmit = useCallback(async () => {
    handleOpenLoading()
    await REPOSITORY.wsEmpresa.company
      .createCostCenter(costCenterName)
      .then((res) => {
        if (res?.data?.sMensaje?.includes('Centro de Costos creados: 0')) {
          onStatusError()
        } else {
          onStatusOK(res, 'La acción se ha realizado con éxito')
        }
      })
      .catch((error) => {
        console.error('error', error)
        handleCLoseLoading()
        handleSetTitle(error.response.data.error, error.response.status)
        handleChangeBody(
          <Button
            variant="primary"
            onClick={() => {
              handleClose()
            }}
          >
            Contactar a soporte ahora
          </Button>,
        )
        handleOpen()
      })
    await searchCompanyData(sEmpresa)
  }, [costCenterName])
  return (
    <VStack
      h="70vh"
      mb="40px"
      alignItems="flex-start"
      justifyContent="space-between"
    >
      <VStack alignItems="flex-start" spacing="24px">
        <UnderlineHeading text="Datos del centro de costo" variant="h5" />

        <InputForm
          title="Nombre Centro de costo"
          variant="subtitle3"
          value={costCenterName}
          onChange={onCostCenterChange}
        />
      </VStack>
      <Center mb="20px" mt="10px" w="100%">
        <HStack
          spacing="16px"
          alignSelf="center"
          w="auto"
          h="5vh"
          justifyContent="space-between"
        >
          <Button
            onClick={onGoBack}
            variant="white"
            width={'144px'}
            height={'56px'}
          >
            Cancelar
          </Button>
          <Button
            width={'160px'}
            height={'56px'}
            disabled={!costCenterName.length > 0}
            borderRadius={'8px'}
            bgColor={'#0CC863'}
            onClick={onSubmit}
            {...{
              ...(!costCenterName.length > 0
                ? {
                    bgColor: '#DDDDDD',
                    borderColor: 'transparent',
                    color: '#565656',
                  }
                : {}),
            }}
          >
            Guardar
          </Button>
        </HStack>
      </Center>
    </VStack>
  )
}
